import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IGetDirigidoTramite } from '../shared/interfaces/configuracion';
import { API_URL } from 'lib-base';

@Injectable({
  providedIn: 'root'
})
export class DirigidoTramiteService {
  readonly baseUrl: string;

  constructor(@Inject(API_URL) public apiUrl: string, private readonly http: HttpClient) {
    this.baseUrl = `${this.apiUrl}/api/dirigido-tramite`;
  }

  getDirigidoTramite(): Observable<IGetDirigidoTramite[]> {
    return this.http.get<IGetDirigidoTramite[]>(`${this.baseUrl}/public`);
  }
}
